import React, { useState, useEffect } from "react";
import translations from "../translations/LoginDoctorPage.translations.js";

export default function LoginDoctorPage() {
  const getDefaultLang = () => {
    const lang = navigator.language || navigator.userLanguage;
    if (lang && translations[lang]) return lang;
    if (lang && lang.startsWith("es")) return "es";
    if (lang && lang.startsWith("en")) return "en";
    return "en";
  };
  const [lang, setLang] = useState(getDefaultLang());
  const [darkMode, setDarkMode] = useState(false);
  const t = translations[lang] || translations["en"];

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [darkMode]);

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleWhatsappLogin = (e) => {
    e.preventDefault();
    alert(`Se enviará un mensaje de WhatsApp al número: ${phone}`);
    // Aquí va la integración real con WhatsApp API
  };

  const handleGmailLogin = (e) => {
    e.preventDefault();
    alert(`Intentando iniciar sesión con:\nEmail: ${email}\nPassword: ${password}`);
    // Aquí va la integración real con Gmail/Firebase
  };

  return (
    <div className="login-container">
      <header className="header-flex">
        <img
          src="/images/icarolife-doctor.png"
          alt="Logo Doctor"
          className="logo-doctor"
          style={{ width: "64px", height: "64px", marginRight: "1rem" }}
        />
        <h1>IcaroLife</h1>
        <div>
          <button onClick={() => setDarkMode((d) => !d)}>
            {darkMode ? "🌞" : "🌙"}
          </button>
          <button onClick={() => setLang((l) => (l === "es" ? "en" : "es"))}>
            {lang === "es" ? "EN" : "ES"}
          </button>
        </div>
      </header>
      <main>
        <h2>{t.titulo}</h2>
        {/* Login por WhatsApp */}
        <form className="login-form" onSubmit={handleWhatsappLogin}>
          <label htmlFor="phone">{t.telefono}</label>
          <input
            id="phone"
            type="tel"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            required
            placeholder="+58 412 1234567"
          />
          <button type="submit" className="btn btn-whatsapp btn-login">
            {t.loginWhatsapp}
          </button>
        </form>
        <div className="login-or">{t.o}</div>
        {/* Login por Gmail */}
        <form className="login-form" onSubmit={handleGmailLogin}>
          <label htmlFor="email">{t.correo}</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="usuario@email.com"
          />

          <label htmlFor="password">{t.contrasena}</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="btn btn-paciente btn-login">{t.loginGmail}</button>
        </form>
      </main>
    </div>
  );
}